import { FiscalNoteModel } from "../../../../../../domain/models/fiscal-note";
import { makeRemoteCancelFiscalNoteRecorrency } from "../../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

const cancelRecurrenceFiscalNote = async (noteId: number): Promise<FiscalNoteModel> =>
  makeRemoteCancelFiscalNoteRecorrency().cancelRecurrenceNote(noteId);

export default cancelRecurrenceFiscalNote;
